import Controller from './helpers/Controller';
import common from './controllers/common';
import SearchLocator from './components/SearchLocator';
// import MobileMenu from './components/MobileMenu';

const modules = [
  common,
  SearchLocator,
  // MobileMenu,
];
const controller = new Controller(modules);
controller.ready();
